<video [style.width.px]="width" [style.height.px]="width*0.7" *ngIf="src" id="video_x_{{idx}}" class="video-js vjs-big-play-centered video-panel-x" controls autoplay
  preload="auto" poster="{{poster}}" data-setup="{}">
  <source src="{{src}}" type='application/x-mpegURL'>
  <p class="vjs-no-js">
    To view this video please enable JavaScript, and consider upgrading to a web browser that
    <a href="https://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
  </p>
</video>